// extracted by mini-css-extract-plugin
export var cardHeader = "_u7-0";
export var reorderHandle = "_u7-3";
export var titleArea = "_u7-1";
export var titleAreaWithHandle = "_u7-2";